import routeHelper from '../components/common/classes/routeHelper';
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const cabinetIdentifier = await sourceEvaluator(source.cabinetIdentifier);
  if (cabinetIdentifier === undefined) return;
  const uuid = await sourceEvaluator(source.uuid);
  if (uuid === undefined) return;

  // looks like web doesn't rely on the formTypeIdentifier and iPad does not require it.
  // For completeness, it's nice to have the 'right' identifier, but 'form' will do
  // when that's not easy to come by
  const formTypeIdentifier = await sourceEvaluator(source.formTypeIdentifier);
  const url = "/cabinets/".concat(cabinetIdentifier, "/").concat(formTypeIdentifier || 'form', "/").concat(uuid);
  routeHelper.updateURL(url);
};
export default {
  evaluate
};